"use client";
import { Image } from "@chakra-ui/react";
import React from "react";

export function NYSRA(props: any): React.ReactElement {
  return (
    <>
      <Image
        src="https://www.nysra.org/wp-content/themes/nysra/library/images/nysra-logo.svg"
        alt="New York State Restaurant Association"
      />
    </>
  );
}

export default NYSRA;
